import React from 'react'

const Footer = () => {
  return (
    <footer
      style={{
        background: 'linear-gradient(135deg, #1b62d4bb 0%, #1d50dbd0 100%)',
        color: '#ffffff',
        padding: '3rem 1.5rem 1.5rem',
        marginTop: '2rem',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '2rem',
        }}
      >
        <div>
          <h3 style={{ marginBottom: '0.75rem', fontSize: '1.2rem' }}>ANKURIVF</h3>
          <p style={{ lineHeight: 1.7, color: '#dbeafe', margin: 0 }}>
            Compassionate fertility care with advanced treatments, personalized support, and a commitment to helping families grow.
          </p>
        </div>

        <div>
          <h4 style={{ marginBottom: '0.75rem' }}>Quick Links</h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, lineHeight: 1.8, color: '#dbeafe' }}>
            <li><a href="#about" style={{ color: '#dbeafe', textDecoration: 'none' }}>About Us</a></li>
            {/* <li><a href="#treatments" style={{ color: '#dbeafe', textDecoration: 'none' }}>Treatments</a></li> */}
            <li><a href="#stories" style={{ color: '#dbeafe', textDecoration: 'none' }}>Success Stories</a></li>
            <li><a href="#contact" style={{ color: '#dbeafe', textDecoration: 'none' }}>Contact  Us</a></li>
          </ul>
        </div>

        <div>
          <h4 style={{ marginBottom: '0.75rem' }}>Contact</h4>
          <p style={{ margin: '0 0 0.5rem', color: '#dbeafe' }}>📍 Martyr Anil Baghi Road, Ferozepur City, Punjab 152002</p>
          <p style={{ margin: '0 0 0.5rem', color: '#dbeafe' }}>📞 +91 97798 48111</p>
          <p style={{ margin: 0, color: '#dbeafe' }}>✉️ ivfankur@gmail.com</p>
        </div>
      </div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '1.5rem auto 0',
          paddingTop: '1rem',
          borderTop: '1px solid rgba(255,255,255,0.2)',
          textAlign: 'center',
          color: '#dbeafe',
          fontSize: '0.95rem',
        }}
      >
        <div>© 2026 ANKURIVF. All rights reserved.</div>
        <div style={{ marginTop: '0.4rem' }}>
          Designed and Developed by{' '}
          <a
            href="https://ganotras.in"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#ffffff', textDecoration: 'underline' }}
          >
            DKG DevOps Tech
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
